import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

const ActionButton = ({ icon, text, onClick }) => (
  <Button
    variant="outline"
    onClick={onClick}
    className={cn(
      "rounded border border-primary flex items-center gap-1 justify-center p-3"
    )}
  >
    <img 
      loading="lazy" 
      src={icon} 
      className="w-6 h-6 object-contain" 
      alt="" 
    />
    <span>{text}</span>
  </Button>
);

export default function ScreeningTestPopup({ onClose, open }) {
  const handleEmailSend = () => {
    alert("Email Sent!");
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText("https://aievaluator.in/kdsjfvugfvyv");
    alert("Link Copied!");
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="max-w-[600px] bg-[#1e1e22] text-white border-[#1e1e22]">
        <DialogHeader className="text-center">
          <DialogTitle className="text-3xl text-white">
            Your Screening Test Link
          </DialogTitle>
          <DialogDescription className="text-[#cfcfcf] font-semibold text-lg mt-10 tracking-[0.24px]">
            Click the link below to start your Screening test
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col items-center w-full max-w-[803px]">
          <div className="flex items-center gap-12 mt-10 justify-center">
            <ActionButton
              icon="https://cdn.builder.io/api/v1/image/assets/TEMP/b3ce4907b90acf4aea66c202d6ca1303666aa5f7d8c0a3e1b693137ded746030"
              text="Send E-mail"
              onClick={handleEmailSend}
            />
            <ActionButton
              icon="https://cdn.builder.io/api/v1/image/assets/TEMP/7e01904192f63dead901e1280aa1b607a5f18e9d3a55951425822ee9324d3ca7"
              text="Copy Link"
              onClick={handleCopyLink}
            />
          </div>
          
          <div className={cn(
            "rounded-[22px] bg-primary self-center flex items-center gap-2.5 mt-10",
            "w-full max-w-[626px] text-primary-foreground tracking-[0.24px]",
            "justify-center flex-wrap p-3"
          )}>
            <img
              loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/c6d50539e7c372e93521beafef79bc2996f1ededfb10f646205686c27bfd0bc2"
              className="w-[30px] h-[30px] object-contain rounded-[22px]"
              alt=""
            />
            <span className="text-primary-foreground">
              https://aievaluator.in/kdsjfvugfvyv
            </span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
